import { useQuery } from "@apollo/client";

import { ProjectStatisticsGetByIdDocument } from "./queries.generated";

export function useProjectStatisticsGetById(projectId: string) {
    return useQuery(ProjectStatisticsGetByIdDocument, {
        variables: { projectId },
    });
}
